/* global axios */
import ApiClient from './ApiClient';

class BugReportsAPI extends ApiClient {
  constructor() {
    super('bug_reports', { accountScoped: true });
  }

  create(bugReportData) {
    return axios.post(this.url, bugReportData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  get({ page = 1, status, search, userId, dateFrom, dateTo, perPage = 25, labelIds }) {
    return axios.get(this.url, {
      params: {
        page,
        status,
        search,
        user_id: userId,
        date_from: dateFrom,
        date_to: dateTo,
        per_page: perPage,
        label_ids: labelIds,
      },
    });
  }

  show(bugReportId) {
    return axios.get(`${this.url}/${bugReportId}`);
  }

  update(bugReportId, status) {
    return axios.patch(`${this.url}/${bugReportId}`, {
      bug_report: { status },
    });
  }

  timeline(bugReportId) {
    return axios.get(`${this.url}/${bugReportId}/timeline`);
  }
}

export default new BugReportsAPI();
